// src/pages/produk/PaketStarterKit.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const PaketStarterKit = ({ setKeranjang }) => {
  // Data detail untuk Paket Starter Kit ini
  const paketStarterKit = {
    id: 'paket-starter-001',
    nama: "Paket Starter Kit IoT Lengkap",
    harga: 3500000,
    stok: 10,
    image: 'https://via.placeholder.com/600x400/9400D3/FFFFFF?text=Paket+Starter+Kit',
    deskripsi: "Paket starter kit ini adalah solusi sempurna bagi Anda yang ingin memulai eksplorasi di dunia Internet of Things. Dirancang untuk pemula hingga menengah, paket ini mencakup semua komponen esensial yang Anda butuhkan untuk membangun berbagai proyek IoT yang inovatif. Belajar, bereksperimen, dan wujudkan ide Anda dengan mudah!",
    isiPaket: [
      { nama: "Mikrokontroler ESP32 DevKit C", jumlah: 1 },
      { nama: "Sensor Suhu & Kelembaban (DHT22)", jumlah: 1 },
      { nama: "Sensor Kelembaban Tanah", jumlah: 1 },
      { nama: "Sensor Aliran Air", jumlah: 1 },
      { nama: "Modul Relay 4 Channel", jumlah: 1 },
      { nama: "Kabel Jumper Male-Female (40pcs)", jumlah: 1 },
      { nama: "Protoboard 830 Poin", jumlah: 1 },
      { nama: "Set Resistor & Kapasitor", jumlah: "1 set" }, // Tambahkan tanda kutip di sini

      { nama: "LED Berbagai Warna", jumlah: 10 },
      { nama: "Adaptor Power 5V", jumlah: 1 },
      { nama: "Buku Panduan Proyek (E-Book)", jumlah: 1 },
    ],
    manfaat: [
      "Cocok untuk pemula dan edukasi.",
      "Semua komponen esensial dalam satu paket.",
      "Hemat biaya dibandingkan beli satuan.",
      "Dilengkapi panduan proyek untuk memulai.",
      "Dasar yang kuat untuk pengembangan proyek lanjutan.",
    ]
  };

  const [jumlah, setJumlah] = useState(1); // State untuk jumlah produk yang akan ditambahkan

  const tambahKeKeranjang = () => {
    // Cari apakah produk sudah ada di keranjang untuk memperbarui jumlah
    setKeranjang(prevKeranjang => {
      const existingItemIndex = prevKeranjang.findIndex(item => item.id === paketStarterKit.id);

      if (existingItemIndex > -1) {
        // Jika sudah ada, update jumlahnya
        const updatedKeranjang = [...prevKeranjang];
        updatedKeranjang[existingItemIndex].jumlah += jumlah;
        return updatedKeranjang;
      } else {
        // Jika belum ada, tambahkan produk baru
        return [...prevKeranjang, { ...paketStarterKit, jumlah: jumlah }];
      }
    });
    alert(`${jumlah}x ${paketStarterKit.nama} berhasil ditambahkan ke keranjang!`);
  };

  const handleJumlahChange = (e) => {
    const value = parseInt(e.target.value);
    if (value > 0 && value <= paketStarterKit.stok) {
      setJumlah(value);
    } else if (value > paketStarterKit.stok) {
        setJumlah(paketStarterKit.stok); // Batasi hingga stok maksimum
        alert(`Jumlah maksimal yang dapat ditambahkan adalah ${paketStarterKit.stok}.`);
    } else if (value <= 0) {
        setJumlah(1); // Minimal 1
    }
  };


  return (
    <div className="bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200 min-h-screen py-10 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 mb-8 text-center">
          {paketStarterKit.nama}
        </h1>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6 md:p-8 flex flex-col lg:flex-row gap-8 transition-colors duration-300">
          {/* Gambar Produk */}
          <div className="lg:w-1/2 flex justify-center items-center p-4">
            <img
              src={paketStarterKit.image}
              alt={paketStarterKit.nama}
              className="w-full max-w-lg h-auto rounded-lg shadow-md object-cover"
            />
          </div>

          {/* Detail Produk & Aksi */}
          <div className="lg:w-1/2 flex flex-col">
            <h2 className="text-2xl md:text-3xl font-bold text-blue-700 dark:text-blue-400 mb-4">{paketStarterKit.nama}</h2>
            <p className="text-lg text-gray-700 dark:text-gray-300 mb-6 leading-relaxed">
              {paketStarterKit.deskripsi}
            </p>

            <div className="flex items-baseline mb-4">
              <span className="text-gray-600 dark:text-gray-400 text-lg mr-2">Harga:</span>
              <span className="text-green-600 dark:text-green-400 font-extrabold text-4xl">
                Rp{paketStarterKit.harga.toLocaleString('id-ID')}
              </span>
            </div>

            <div className="flex items-center mb-6">
              <span className="text-gray-600 dark:text-gray-400 mr-3">Jumlah:</span>
              <input
                type="number"
                min="1"
                max={paketStarterKit.stok}
                value={jumlah}
                onChange={handleJumlahChange}
                className="w-20 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-gray-50 dark:bg-gray-700 dark:text-gray-100 text-center"
              />
              <span className="ml-3 text-gray-600 dark:text-gray-400 text-sm">Stok: {paketStarterKit.stok}</span>
            </div>

            <button
              onClick={tambahKeKeranjang}
              className="w-full bg-blue-600 text-white font-semibold py-3 rounded-lg hover:bg-blue-700 transition duration-200 flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={paketStarterKit.stok === 0}
            >
              <span className="text-xl">🛒</span>
              <span>{paketStarterKit.stok > 0 ? 'Tambah ke Keranjang' : 'Stok Habis'}</span>
            </button>

            {paketStarterKit.stok === 0 && (
                <p className="text-red-500 text-sm text-center mt-2">Maaf, stok paket ini sedang kosong.</p>
            )}

            <div className="mt-8 text-gray-700 dark:text-gray-300 text-sm">
                <p className="mb-2">SKU: PKT-IOT-001</p>
                <p>Kategori: Paket Starter Kit, Produk</p>
            </div>
          </div>
        </div>

        {/* Bagian Isi Paket / Komponen Termasuk */}
        <section className="mt-12 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">Isi Paket & Komponen Termasuk</h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700 dark:text-gray-300 text-lg">
            {paketStarterKit.isiPaket.map((item, index) => (
              <li key={index} className="flex items-center">
                <span className="text-blue-500 dark:text-blue-300 text-xl mr-2">✔️</span>
                <span>{item.nama} ({item.jumlah})</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Bagian Manfaat & Keunggulan */}
        <section className="mt-12 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">Mengapa Pilih Paket Ini?</h2>
          <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 text-lg space-y-2">
            {paketStarterKit.manfaat.map((manfaat, index) => (
              <li key={index}>{manfaat}</li>
            ))}
          </ul>
        </section>

        {/* CTA Section */}
        <section className="text-center mt-16 bg-blue-600 dark:bg-blue-900 text-white p-8 rounded-lg shadow-lg">
          <h2 className="text-3xl font-bold mb-4">Mulai Petualangan IoT Anda Sekarang!</h2>
          <p className="text-lg mb-6">
            Dapatkan semua yang Anda butuhkan dalam satu paket praktis dan hemat.
          </p>
          <Link to="/toko">
            <button className="bg-white text-blue-600 dark:bg-blue-200 dark:text-blue-900 font-semibold px-8 py-3 rounded-full shadow-lg hover:bg-gray-100 transform hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50">
              Lihat Semua Produk
            </button>
          </Link>
        </section>

      </div>
    </div>
  );
};

export default PaketStarterKit;
